import { configureStore } from "@reduxjs/toolkit";
import { lifePlansApi, longTermDisabilityPlansApi, shortTermDisabilityPlansApi } from "EmployerApplication/api";

import { siteConfigSlice } from "Common/Redux/siteConfig";

import { benAdminRenewalApi, dentalPlansApi, visionPlansApi, employerRenewalApplicationApi } from "./benAdminRenewal.api";

export const reducerSlices = {
  [siteConfigSlice.name]: siteConfigSlice.reducer,
  [benAdminRenewalApi.reducerPath]: benAdminRenewalApi.reducer,
  [dentalPlansApi.reducerPath]: dentalPlansApi.reducer,
  [visionPlansApi.reducerPath]: visionPlansApi.reducer,
  [lifePlansApi.reducerPath]: lifePlansApi.reducer,
  [longTermDisabilityPlansApi.reducerPath]: longTermDisabilityPlansApi.reducer,
  [shortTermDisabilityPlansApi.reducerPath]: shortTermDisabilityPlansApi.reducer,
  [employerRenewalApplicationApi.reducerPath]: employerRenewalApplicationApi.reducer,
};

export const createStore = (preloadedState) => {
  const store = configureStore({
    reducer: reducerSlices,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware()
        .concat(benAdminRenewalApi.middleware)
        .concat(dentalPlansApi.middleware)
        .concat(visionPlansApi.middleware)
        .concat(lifePlansApi.middleware)
        .concat(longTermDisabilityPlansApi.middleware)
        .concat(shortTermDisabilityPlansApi.middleware)
        .concat(employerRenewalApplicationApi.middleware),
    preloadedState,
  });
  return store;
};
